/**
 * Barra factor model page — characteristic exposures, factor returns, risk model.
 */
import React from "react";
import { Sigma } from "lucide-react";
import { useAuth } from "../App";
import { FactorsV2Tab } from "../components/factors/FactorsV2Tab";

export default function BarraPage() {
  const { token } = useAuth();
  return (
    <div className="p-6 space-y-5" data-testid="barra-page">
      <div>
        <h1 className="text-2xl font-bold flex items-center gap-2">
          <Sigma className="w-6 h-6 text-primary" /> Barra Factor Model
        </h1>
        <p className="text-sm text-muted-foreground mt-1 max-w-3xl">
          Characteristic-based factor model: exposures from firm fundamentals and
          price behavior, daily cross-sectional regressions for factor returns, and
          an EWMA factor covariance risk model.
        </p>
      </div>
      <FactorsV2Tab token={token} />
    </div>
  );
}
